export default __webpack_public_path__ + "static/media/EM1980.34I-43603_-26100_0.5fb2518c.jpg";